module.exports = __webpack_public_path__ + "static/img/dagou.45dad4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yanzi/dagou.png
// module id = 6Wiv
// module chunks = 1